import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import Box from "@mui/material/Box";
import { useCsValue } from "@plansoft-configuration-renderer/framework";
import { CommonComponentsContext } from "../../Common/CommonComponents";
export function InfoValueDescription(props) {
    var _a;
    const value = useCsValue();
    const { Markdown } = useContext(CommonComponentsContext);
    const text = (_a = value.description) !== null && _a !== void 0 ? _a : "";
    if (props.textMode === "markdown") {
        return (_jsx(Box, { children: _jsx(Markdown, { src: text }) }));
    }
    return _jsx(Box, { children: text });
}
//# sourceMappingURL=InfoValueDescription.js.map